import DarkModeIcon from '@mui/icons-material/DarkMode'
import type { SvgIconProps } from '@mui/material'
import { memo } from 'react'

const DarkMode = memo((props: SvgIconProps) => {
    const { color, ...other } = props
    return (
        <DarkModeIcon data-testid="Icon__DarkMode" css={{ color }} {...other} />
    )
})

export default DarkMode
